<template>
  <section id="Create">
    <b-container>
      <div class="intros">
        <div class="section-title">
          <h2>fan’s</h2>
          <h3>choice</h3>
        </div>
        <p>Looking for ultimate flexibility? This plan is for you. Build a 20-Game Plan that works for your schedule!
        </p>
        <div class="choose">
          <h3>choose your games</h3>
          <div class="game-types">
            <img class="one" :src="require('@/assets/images/choice/a-games.png')" />
            <img class="two" :src="require('@/assets/images/choice/b-games.png')" />
            <img class="three" :src="require('@/assets/images/choice/c-games.png')" />
          </div>
        </div>
      </div>

      <div class="plans">
        <div class="plan" v-for="plan in plans" :key="plan.title">
          <div class="plan__title">{{ plan.title }}</div>
          <div class="plan__cards">
            <div class="wrapper">
              <div class="plan__cards--card" v-for="card in plan.cards" :key="plan.title + card.date">
                <div class="holder">

                  <div class="date">{{ card.date }}</div>
                  <div class="time">{{ card.time }}</div>
                  <div class="vs">VS</div>
                  <img class="logo" :src="require('@/assets/images/choice/teams/' + card.logo)" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="intros second">
        <div class="section-title">
          <h2>SEATING</h2>
          <h3>AND PRICING</h3>
        </div>
        <div class="choose">
          <h3>choose your seat</h3>
          <p>Same seat is <strong>NOT</strong> guaranteed for all 20 games with Fan's Choice Plan</p>
        </div>
      </div>
      <img class="map" src="@/assets/images/choice/map.jpg" />
      <img class="map mobile" src="@/assets/images/choice/map-mobile.png" />
      <div class="buttons">
        <a href="https://texasrangers.turnstyle.fan/2026-offers" target="_blank" class="button">buy fan's choice
          plan</a>
      </div>
    </b-container>
  </section>
</template>

<script>
import { createData } from "@/data/createData.js";

export default {
  name: "Create",
  components: {},
  data() {
    return {
      plans: createData(),
      // seats: [
      //   {
      //     "hex": "#800000",
      //     "section": "Select Infield Mezzanine",
      //     "price": "$102",
      //     "total": "$2,040"
      //   },
      //   {
      //     "hex": "#C00000",
      //     "section": "Infield Mezzanine",
      //     "price": "$90",
      //     "total": "$1,800"
      //   },
      //   {
      //     "hex": "#FF9966",
      //     "section": "Mezzanine",
      //     "price": "$65",
      //     "total": "$1,300"
      //   },
      //   {
      //     "hex": "#CC9966",
      //     "section": "Infield Pavilion",
      //     "price": "$55",
      //     "total": "$1,100"
      //   },
      //   {
      //     "hex": "#FFFF00",
      //     "section": "Corner Mezzanine",
      //     "price": "$54",
      //     "total": "$1,080"
      //   },
      //   {
      //     "hex": "#E67300",
      //     "section": "Outfield Mezzanine",
      //     "price": "$51",
      //     "total": "$1,020"
      //   },
      //   {
      //     "hex": "#000080",
      //     "section": "Baseline Pavilion",
      //     "price": "$48",
      //     "total": "$960"
      //   },
      //   {
      //     "hex": "#808000",
      //     "section": "Corner Pavilion",
      //     "price": "$39",
      //     "total": "$780"
      //   },
      //   {
      //     "hex": "#CCCC33",
      //     "section": "Lower Pavilion",
      //     "price": "$30",
      //     "total": "$600"
      //   },
      //   {
      //     "hex": "#FFCCCC",
      //     "section": "Upper Box",
      //     "price": "$30",
      //     "total": "$600"
      //   },
      //   {
      //     "hex": "#99E6E6",
      //     "section": "Upper Reserved",
      //     "price": "$24",
      //     "total": "$480"
      //   }
      // ],
    };
  },
};
</script>

<style lang="scss">
#Create {
  width: 100%;
  // background-color: #ba0026;
  padding: 179px 0 165px;
  background: url("~@/assets/images/choice/bg.jpg") no-repeat;
  background-size: cover;
  background-color: #c02133;
  position: relative;

  &::before {
    background-image: url('~@/assets/images/hero/long-glow-bar.png');
    background-position: 50%;
    bottom: -210px;
    content: "";
    height: 470px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 2;
    background-size: contain;

    @media screen and (max-width: 1200px) {
      background-size: cover;
    }
  }

  @media screen and (max-width: $md) {
    padding: 140px 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (min-width: 1200px) {
      max-width: 1558px;
      width: 95%;
    }
  }

  .intros {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 45px;
    width: 100%;


    .section-title {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 15px;

      h2 {
        color: var(--STH-White, #FFF);
        text-align: center;
        font-family: "Druk XCond";
        font-size: 125px;
        font-style: normal;
        font-weight: 950;
        line-height: 100px;
        text-transform: uppercase;
        margin-bottom: 0;
      }

      h3 {
        color: var(--STH-White, #FFF);
        text-align: center;
        font-family: Gotham;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 9px;
        text-transform: uppercase;
        margin-bottom: 0;
      }
    }

    p {
      color: var(--STH-White, #FFF);
      text-align: center;
      font-family: Gotham;
      font-size: 16px;
      font-style: normal;
      font-weight: normal;
      line-height: 24px;
      max-width: 503px;
      margin-bottom: 0;
      /* 150% */
    }

    .choose {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 4px;
      border: 2px solid var(--STH-Dark-Blue, #1E376D);
      background: var(--STH-Dark-UI, linear-gradient(0deg, rgba(20, 38, 76, 0.80) 0%, rgba(30, 55, 109, 0.80) 100%));
      max-width: 766px;
      height: 149px;
      width: 100%;
      padding: 25px;

      @media screen and (max-width: $md) {
        flex-direction: column;
        height: 201px;
        gap: 25px;
      }

      h3 {
        color: var(--STH-White, #FFF);
        font-family: Druk;
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0.72px;
        text-transform: uppercase;
        text-align: left;
        margin-bottom: 0;

        @media screen and (max-width: $md) {
          line-height: 27px;
        }
      }

      .game-types {
        display: flex;
        align-items: center;

        gap: 30px;

        img {
          height: 148.75px;
          object-fit: contain;

          @media screen and (max-width: $md) {
            margin-top: -27.75px;
            height: 111.56px;
          }

          &.one {
            margin-left: -88px;

            @media screen and (max-width: $md) {
              margin-left: -46px;
            }
          }

          &.two {
            margin-left: -176px;

            @media screen and (max-width: $md) {
              margin-left: -132px;
            }
          }

          &.three {
            margin-left: -176px;

            @media screen and (max-width: $md) {
              margin-left: -132px;
            }
          }
        }
      }
    }

    &.second {
      flex-direction: row;
      justify-content: space-between;
      gap: 50px;

      @media screen and (max-width: $lg) {
        flex-direction: column;
        gap: 45px;
      }

      .section-title {
        h2 {
          text-align: left;
        }

        h3 {
          text-align: left;
        }
      }

      .choose {
        gap: 80px;

        @media screen and (max-width: $md) {
          flex-direction: column;
          gap: 25px;
          height: auto;

          h3 {
            color: var(--STH-White, #FFF);
            text-align: center;
            font-family: "Druk Wide";
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 11px;
            letter-spacing: 0.55px;
            text-transform: uppercase;
          }
        }

        p {
          text-align: left;
          max-width: 397px;
          color: var(--STH-White, #FFF);
          font-family: Gotham;
          font-size: 16px;
          font-style: normal;
          font-weight: normal;
          line-height: 24px;

          @media screen and (max-width: $md) {
            text-align: center;
          }

          /* 150% */

          strong {
            font-weight: 700;
          }
        }
      }
    }
  }

  .map {
    width: 100%;
    margin: 45px 0;

    @media screen and (max-width: $md) {
      display: none;
    }

    &.mobile {
      display: none;

      @media screen and (max-width: $md) {
        display: block;
        border-radius: 4px;
      }
    }
  }

  .plans {
    display: flex;
    // flex-direction: row;
    width: 100%;
    margin-top: 45px;
    margin-bottom: 80px;
    // background-color: #f2f2f2;
    // @media (max-width: 1200px) {
    flex-direction: column;
    gap: 25px;

    @media screen and (max-width: $sm) {
      width: 100vw;
    }

    // }
    .plan {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: row;
      color: #000000;

      @media screen and (max-width: $md) {
        flex-direction: column;
      }

      &__title {
        color: #FFF;
        font-family: "Druk Wide";
        font-size: 20px;
        font-style: normal;
        font-weight: bold;
        line-height: 15px;
        /* 100% */
        letter-spacing: 2px;
        text-transform: uppercase;
        writing-mode: vertical-lr;
        transform: rotate(180deg);
        padding: 25px;
        border-radius: 4px 0 0 4px;
        border-top: 2px solid var(--STH-Dark-Blue, #1E376D);
        border-bottom: 2px solid var(--STH-Dark-Blue, #1E376D);
        border-left: 2px solid var(--STH-Dark-Blue, #1E376D);
        background: var(--STH-Dark-UI, linear-gradient(0deg, rgba(20, 38, 76, 0.80) 0%, rgba(30, 55, 109, 0.80) 100%));

        @media screen and (max-width: $md) {
          writing-mode: initial;
          transform: none;
          border-radius: 0;
        }
      }

      &__cards {
        width: 100%;
        border-radius: 0 4px 4px 0;
        background: var(--STH-Light-Gradient, linear-gradient(90deg, #FFF 25%, #E7E7E7 100%));
        padding: 45px;


        @media screen and (max-width: $md) {
          padding: 25px;
          border-radius: 0;
        }

        .wrapper {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
          gap: 29px;
          width: 100%;

          @media (max-width: 1200px) {
            gap: 15px;
          }

          @media (max-width: $sm) {
            gap: 10px;
          }
        }

        &--card {
          position: relative;
          flex: 1 1 129px;
          max-width: calc((100% - 8 * 29px) / 9);
          transform: translateY(0);
          transition: transform 0.3s ease-in-out;
          border-radius: 4px;
          background: var(--STH-White, #FFF);
          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.10);

          @media (max-width: 1400px) {
            max-width: calc((100% - 6 * 29px) / 7);
          }

          @media (max-width: 1200px) {
            max-width: calc((100% - 6 * 15px) / 7);
          }

          @media (max-width: 992px) {
            max-width: calc((100% - 4 * 15px) / 5);
          }

          @media (max-width: 768px) {
            max-width: calc((100% - 2 * 15px) / 3);
          }

          @media (max-width: $sm) {
            max-width: calc((100% - 2 * 10px) / 3);
          }

          &:hover {
            @media (min-width: 416px) {
              transform: translateY(-10px);

              .holder {
                color: var(--STH-Red, #C50D33);

              }
            }
          }

          .holder {
            display: flex;
            flex-direction: column;
            padding: 35px 10px;
            border-radius: 0 0 40px 0;
            gap: 10px;
            width: 100%;
            color: var(--STH-Dark-Blue, #1E376D);
            transition: all 0.3s ease-in-out;
          }

          .opening {
            position: absolute;
            top: -4px;
            left: calc(50% - 4px);
            transform: translateX(-50%);
            width: 90%;
            max-width: 114px;
          }
        }

        .day,
        .date,
        .time {
          position: relative;
          font-family: BertholdCondensed;
          color: #000000;
          // color: #fff;
          line-height: 1;
          text-transform: uppercase;
        }

        .date {
          color: inherit;
          text-align: center;
          font-family: Druk;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 13px;
          letter-spacing: 0.9px;
          text-transform: uppercase;
        }

        .time {
          color: inherit;
          font-family: "Druk Wide";
          font-size: 11px;
          font-style: normal;
          font-weight: 700;
          line-height: 8px;
          letter-spacing: 0.55px;
          text-transform: uppercase;
        }

        .vs {
          color: inherit;
          font-family: Gotham;
          font-size: 12px;
          font-style: normal;
          font-weight: normal;
          line-height: 8px;
          /* 150% */
        }


        .logo {
          position: relative;
          height: 40px;
        }
      }
    }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: center;
    justify-content: center;
    width: 100%;

    // gap: 50px;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 18px 45px;
      color: var(--STH-White, #FFF);
      text-align: center;
      font-family: Druk;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 13px;
      letter-spacing: 0.36px;
      text-decoration: none;
      text-transform: uppercase;
      // background-color: #fff;
      // background-color: #003278;
      border-radius: 4px;
      background: #2D984B;
    }
  }
}
</style>
